import { mergeObject } from "df-helpers/dist/merge-object/merge-object";
import { be_app_info } from "./be-shared/be-app-info";
import { be_app_info as be_app_info_in_lib } from "df-frontend-02/dist/apps/shared/app-shared/be-app-info";

//To ensure that the be_app_info is merged before other files are imported

mergeObject(be_app_info_in_lib, be_app_info);
